module.exports = __webpack_public_path__ + "static/img/CAC.2a291f94.png";